import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { Callout } from '../../molecules';
export const CalloutStatementsNoResult = memo(({ onClearFilters }) => {
    return (_jsx(Callout, { icon: "Info", title: "No results", message: "No results available for your selection", variant: "secondary", contained: true, small: true, ctas: [
            {
                variant: 'secondary',
                label: 'Clear filters',
                onPress: onClearFilters,
                size: 'base',
                style: { minWidth: 130 },
            },
        ] }));
});
